import * as React from 'react';
import {
    Create,
} from 'react-admin';

import BlogArticleEditCreate from "./BlogArticleEditCreate";
import PostEditActions from "../../_common/PostEditActions";
import {copyToS3bucket} from "../../_common/Transform";

export const BlogArticleCreate = props => {

    const {location, resource} = props;
    const {search} = location;

    //const redirect = useRedirect()

    let idSource = '';
    //let bookingId = '';
    if(search){
        let url = new URL('https://test/' + search);
        idSource = url.searchParams.get('idSource')
        //bookingId = url.searchParams.get('bookingId')
    }


    return (
        <Create
            {...props}
            transform={(event) => copyToS3bucket(resource, event)}
            title={''}
            // onSuccess={() => idSource ? props.history.goBack() : redirect('list', props.basePath)}
            //onSuccess={() => props.history.goBack()}
            //onSuccess={onSuccessData}
            actions={<PostEditActions/>}
            //fullWidth
            //   undoable={false} //Подтверждение удаления
            //   actions={<PostEditActions/>}
        >
            <BlogArticleEditCreate idSource={idSource}/>
        </Create>
    )
};